/* rails-erb-loader-dependencies validators/minimum_bid_validator */

ClientSideValidations.validators.local["minimum_bid"] = function(element, options) {
  const minimumBid = element.data('minimumBid');

  if (element.val() < minimumBid) {
    const error = element.data('minimumBidError');

    return error;
  }
}
